import type { QrScannerProps } from './qrScannerProps'

/** The web app does not scan; its scan step says so instead. */
export const qrScannerSupported = false

export function QrScanner(_props: QrScannerProps): null {
  return null
}
